import { useEffect } from 'react';
import { EMITTER_CONSTANTS } from '@/shared/config';
import emitter from '@/shared/lib/eventEmitter';
import { attachSocketListeners, detachSocketListeners } from './registry';

/**
 * Keeps the app's socket event listeners attached for the lifetime of the tree. Attaches them on mount, re-attaches on the socket attach signal and detaches on the disconnect signal, then removes both emitter subscriptions and detaches once more on unmount.
 *
 * @returns Nothing.
 */
const useSocketListeners = () => {
  useEffect(() => {
    attachSocketListeners();
    const onConnect = emitter.addListener(
      EMITTER_CONSTANTS.SOCKET_ATTACH_LISTENERS,
      attachSocketListeners,
    );
    const onDisconnect = emitter.addListener(
      EMITTER_CONSTANTS.SOCKET_DISCONNECTED,
      detachSocketListeners,
    );
    return () => {
      onConnect.remove();
      onDisconnect.remove();
      detachSocketListeners();
    };
  }, []);
};

export default useSocketListeners;
